import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import YouTube from 'react-youtube';

function toYouTubeId(value) {
  if (!value || typeof value !== 'string') {
    return '';
  }
  const trimmed = value.trim();
  if (/^[\w-]{11}$/.test(trimmed)) {
    return trimmed;
  }
  try {
    const url = new URL(trimmed);
    if (url.hostname.includes('youtu.be')) {
      return url.pathname.replace('/', '').slice(0, 11);
    }
    const fromQuery = url.searchParams.get('v');
    if (fromQuery) {
      return fromQuery;
    }
    const embed = url.pathname.split('/').filter(Boolean);
    const embedIdx = embed.indexOf('embed');
    if (embedIdx >= 0 && embed[embedIdx + 1]) {
      return embed[embedIdx + 1];
    }
  } catch {
    return '';
  }
  return '';
}

function CustomModal({ videoId, show, onHide, title, ...modalProps }) {
  const id = toYouTubeId(videoId);

  return (
    <Modal
      {...modalProps}
      show={show}
      onHide={onHide}
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
      centered
      backdrop="static"
      keyboard={false}
      fullscreen={true}
    >
      <Modal.Body className="p-0 bg-dark position-relative">
        {show && id ? (
          <YouTube
            videoId={id}
            className="ytplay"
            opts={{
              height: '600',
              width: '100%',
              playerVars: {
                modestbranding: 1,
                rel: 0,
                fs: 0,
              },
            }}
          />
        ) : (
          <div id="player" className="ytplay" />
        )}
        <div className="position-absolute w-100" style={{ top: '0px', zIndex: 1049, height: '60px', background: 'black' }}>
          <div
            className="position-absolute bg-transparent border-dark"
            style={{ top: '0px', right: '0px', color: 'white', zIndex: 1050, height: '30px', cursor: 'pointer' }}
            onClick={onHide}
          >
            <AiOutlineClose color="red" size={30} />
          </div>
        </div>
        <div className="position-absolute w-100" style={{ bottom: '0px', zIndex: 1049, height: '45px', background: 'black' }} />
      </Modal.Body>
    </Modal>
  );
}

export default CustomModal;
